import React from 'react'

import { UserRoles } from 'shared/consts'
import { RouteType } from 'shared/types'

import UsersAndSub from 'views/Authorized/views/UsersAndSubscription'
import ErpProductCard from 'views/Authorized/views/ErpProductCard'
import ProductDetails from 'views/Authorized/views/ProductDetails'
import OrdersHistory from 'views/Authorized/views/OrdersHistory'
import Notifications from 'views/Authorized/views/Notifications'
import ProductsList from 'views/Authorized/views/ProductsList'
import Wholesalers from 'views/Authorized/views/Wholesalers'
import SavedCarts from 'views/Authorized/views/SavedCarts'
import Locations from 'views/Authorized/views/Locations'
import Watchlist from 'views/Authorized/views/Watchlist'
import Messages from 'views/Authorized/views/Messages'
import Settings from 'views/Authorized/views/Settings'
import MainCart from 'views/Authorized/views/MainCart'
import BadgeIcon from 'shared/components/BadgeIcon'
import OrderSummary from 'views/Authorized/views/OrderSummary'
import CartFromCsv from 'views/Authorized/views/CartFromCSV'
import BaselinkerOrderSummary from 'views/Authorized/views/BaselinkerOrderSummary'
import InternalProductsList from 'views/Authorized/views/InternalProductsList'
import Contact from 'views/Authorized/views/Contact'
import ClientsCarts from 'views/Authorized/views/ClientsCarts'
import AdditionalServices from 'views/Authorized/views/AdditionalServices'
import Company from 'views/Authorized/views/Company'
import ErrorView from 'views/Authorized/views/Error'
import {
   AlternateEmailSharp,
   Apartment,
   AttachMoneyOutlined,
   Construction,
   EmojiTransportation,
   Group,
   GroupOutlined,
   History,
   MyLocationOutlined,
   Save,
   SearchOutlined,
   SettingsOutlined,
   ShoppingCartCheckout,
   UploadFile,
} from '@mui/icons-material'
import WholesalesKeeping from 'views/Authorized/views/WholesalesKeeping'
import PricingOld from 'views/Authorized/views/PricingOld'
import TireIcon from 'assets/images/tire/tire.png'
import TireSearch from 'views/Authorized/views/TireSearch'
import Replacements from 'views/Authorized/views/Replacements'
import Customers from 'views/Authorized/views/Customers'

const routes: RouteType[] = [
   {
      name: 'routes.mainCart',
      group: 'cart',
      path: 'main-cart',
      icon: React.createElement(BadgeIcon, { badgeType: 'CART' }),
      authority: [UserRoles.SUBSCRIPTION, UserRoles.DEMO, UserRoles.DEMO_SUBSCRIPTION],
      inSidebar: true,
      element: MainCart,
   },
   {
      name: 'routes.ordersHistory',
      group: 'cart',
      path: 'orders-history',
      icon: React.createElement(History),
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.SUBSCRIPTION,
         UserRoles.SALES_REP,
         UserRoles.REGISTERED_USER,
         UserRoles.LOCALIZATION_ADMIN,
      ],
      inSidebar: true,
      element: OrdersHistory,
   },
   {
      name: 'routes.savedCarts',
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.SALES_REP,
         UserRoles.PZU,
         UserRoles.REGISTERED_USER,
         UserRoles.SUBSCRIPTION,
         UserRoles.DEMO,
         UserRoles.DEMO_SUBSCRIPTION,
         UserRoles.LOCALIZATION_ADMIN,
      ],
      group: 'cart',
      icon: React.createElement(Save),
      path: 'saved-carts',
      inSidebar: true,
      element: SavedCarts,
   },
   {
      name: 'routes.clientsCarts',
      group: 'cart',
      icon: React.createElement(ShoppingCartCheckout),
      authority: [UserRoles.MAIN_LOCALIZATION_ADMIN, UserRoles.LOCALIZATION_ADMIN],
      path: 'clients-carts',
      inSidebar: true,
      element: ClientsCarts,
   },
   {
      name: 'routes.csvCart',
      authority: [UserRoles.PRO, UserRoles.ULTRA, UserRoles.NITRO, UserRoles.TURBO],
      inSidebar: true,
      element: CartFromCsv,
      group: 'cart',
      path: 'import-cart',
      icon: React.createElement(UploadFile),
   },
   {
      name: 'routes.company',
      authority: [UserRoles.MAIN_LOCALIZATION_ADMIN],
      inSidebar: true,
      element: Company,
      group: 'settings',
      path: 'company',
      icon: React.createElement(Apartment),
   },
   {
      name: 'routes.locations',
      group: 'settings',
      icon: React.createElement(MyLocationOutlined),
      authority: [UserRoles.MAIN_LOCALIZATION_ADMIN, UserRoles.SUBSCRIPTION, UserRoles.LOCALIZATION_ADMIN],
      path: 'locations',
      inSidebar: true,
      element: Locations,
   },
   {
      name: 'routes.wholesalers',
      group: 'settings',
      icon: React.createElement(EmojiTransportation),
      authority: [UserRoles.MAIN_LOCALIZATION_ADMIN, UserRoles.LOCALIZATION_ADMIN],
      path: 'wholesalers',
      needSub: true,
      inSidebar: true,
      element: Wholesalers,
   },
   {
      name: 'routes.customers',
      group: 'settings',
      icon: React.createElement(GroupOutlined),
      authority: [UserRoles.SUBSCRIPTION],
      path: 'customers',
      needSub: true,
      inSidebar: true,
      element: Customers,
   },
   {
      name: 'routes.additionalServices',
      authority: [UserRoles.LOCALIZATION_ADMIN, UserRoles.MAIN_LOCALIZATION_ADMIN],
      icon: React.createElement(Construction),
      inSidebar: true,
      element: AdditionalServices,
      group: 'settings',
      path: 'additional-services',
   },
   {
      name: 'routes.watchlist',
      group: 'settings',
      icon: React.createElement(SearchOutlined),
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.SUBSCRIPTION,
         UserRoles.SALES_REP,
         UserRoles.LOCALIZATION_ADMIN,
         UserRoles.DEMO,
         UserRoles.DEMO_SUBSCRIPTION,
      ],
      path: 'watchlist',
      inSidebar: true,
      element: Watchlist,
   },
   {
      name: 'routes.settings',
      group: 'settings',
      icon: React.createElement(SettingsOutlined),
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.PZU,
         UserRoles.SALES_REP,
         UserRoles.SUBSCRIPTION,
         UserRoles.LOCALIZATION_ADMIN,
         UserRoles.DEMO,
         UserRoles.DEMO_SUBSCRIPTION,
      ],
      path: 'settings',
      inSidebar: true,
      element: Settings,
   },
   {
      name: 'routes.usersAndSubs',
      group: 'settings',
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.SUBSCRIPTION,
         UserRoles.PZU,
         UserRoles.SALES_REP,
         UserRoles.LOCALIZATION_ADMIN,
      ],
      icon: React.createElement(Group),
      path: 'users-and-subscription',
      inSidebar: true,
      element: UsersAndSub,
   },
   // {
   //    name: 'routes.payments',
   //    group: 'settings',
   //    icon: React.createElement(AttachMoneyOutlinedIcon),
   //    authority: [UserRoles.MAIN_LOCALIZATION_ADMIN],
   //    path: 'payments',
   //    inSidebar: true,
   //    element: Pricing,
   // },
   {
      name: 'routes.contact',
      group: 'settings',
      icon: React.createElement(AlternateEmailSharp),
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.SUBSCRIPTION,
         UserRoles.PZU,
         UserRoles.SALES_REP,
         UserRoles.LOCALIZATION_ADMIN,
         UserRoles.DEMO,
         UserRoles.DEMO_SUBSCRIPTION,
      ],
      path: 'contact',
      inSidebar: true,
      element: Contact,
   },
   {
      name: 'routes.messages',
      group: 'messages',
      icon: React.createElement(BadgeIcon, { badgeType: 'MESSAGES' }),
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.PZU,
         UserRoles.SALES_REP,
         UserRoles.SUBSCRIPTION,
         UserRoles.LOCALIZATION_ADMIN,
         UserRoles.DEMO,
         UserRoles.DEMO_SUBSCRIPTION,
      ],
      inSidebar: false,
      path: 'messages',
      element: Messages,
   },
   {
      name: 'notifications',
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.PZU,
         UserRoles.SALES_REP,
         UserRoles.SUBSCRIPTION,
         UserRoles.LOCALIZATION_ADMIN,
         UserRoles.DEMO,
         UserRoles.DEMO_SUBSCRIPTION,
      ],
      path: 'notifications',
      inSidebar: false,
      element: Notifications,
   },
   {
      name: 'productsList',
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.SALES_REP,
         UserRoles.REGISTERED_USER,
         UserRoles.LOCALIZATION_ADMIN,
         UserRoles.DEMO,
         UserRoles.DEMO_SUBSCRIPTION,
      ],
      path: 'search',
      inSidebar: false,
      element: ProductsList,
   },
   // {
   //    name: 'routes.tireSearch',
   //    icon: React.createElement('img', {
   //       src: TireIcon,
   //       style: { width: 18, height: 'auto' },
   //       alt: 'tire-icon',
   //    }),
   {
      name: 'replacements',
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.SALES_REP,
         UserRoles.REGISTERED_USER,
         UserRoles.LOCALIZATION_ADMIN,
         UserRoles.DEMO,
         UserRoles.DEMO_SUBSCRIPTION,
      ],
      path: 'product/replacements',
      inSidebar: false,
      element: Replacements,
   },

   //    group: 'categories',
   //    authority: [
   //       UserRoles.MAIN_LOCALIZATION_ADMIN,
   //       UserRoles.SALES_REP,
   //       UserRoles.REGISTERED_USER,
   //       UserRoles.LOCALIZATION_ADMIN,
   //       UserRoles.DEMO,
   //       UserRoles.DEMO_SUBSCRIPTION,
   //    ],
   //    path: 'tires-search',
   //    params: '?noFetch=true',
   //    inSidebar: true,
   //    element: TireSearch,
   // },
   {
      name: 'productDetails',
      authority: [UserRoles.SUBSCRIPTION, UserRoles.DEMO, UserRoles.DEMO_SUBSCRIPTION],
      path: 'product',
      inSidebar: false,
      element: ProductDetails,
   },
   {
      name: 'erpProductCard',
      authority: [UserRoles.PZU],
      path: 'erp-product',
      inSidebar: false,
      element: ErpProductCard,
   },
   {
      name: 'orderSummary',
      authority: [
         UserRoles.MAIN_LOCALIZATION_ADMIN,
         UserRoles.SALES_REP,
         UserRoles.SUBSCRIPTION,
         UserRoles.LOCALIZATION_ADMIN,
         UserRoles.DEMO,
         UserRoles.DEMO_SUBSCRIPTION,
      ],
      inSidebar: false,
      element: OrderSummary,
      path: 'order-summary',
   },
   // {
   //    name: 'routes.ourProducts',
   //    authority: [
   //       UserRoles.MAIN_LOCALIZATION_ADMIN,
   //       UserRoles.SALES_REP,
   //       UserRoles.SUBSCRIPTION,
   //       UserRoles.LOCALIZATION_ADMIN,
   //       UserRoles.DEMO,
   //    ],
   //    group: 'shopping',
   //    inSidebar: true,
   //    element: MotorroProducts,
   //    icon: React.createElement('img', { src: logo, style: { maxHeight: 15, width: 'auto' } }),
   //    path: 'our-products',
   // },
   {
      name: 'baselinker-order-summary',
      authority: [UserRoles.REGISTERED_USER],
      inSidebar: false,
      element: BaselinkerOrderSummary,
      path: 'baselinker-summary',
   },
   {
      name: 'internal-search',
      authority: [UserRoles.DATA_MANAGER],
      inSidebar: false,
      element: InternalProductsList,
      path: 'internal-search',
   },
   {
      name: 'error',
      authority: [UserRoles.REGISTERED_USER],
      inSidebar: false,
      element: ErrorView,
      path: 'error-page',
   },
   {
      name: 'wholesales-keeping',
      authority: [UserRoles.MAIN_LOCALIZATION_ADMIN],
      inSidebar: false,
      element: WholesalesKeeping,
      path: 'wholesales-keeping',
   },
]

export default routes
